import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h-2l-3 10v2.5","key":"svg-0"}],["path",{"d":"M16 4h2l3 10v2.5","key":"svg-1"}],["path",{"d":"M10 16l4 0","key":"svg-2"}],["path",{"d":"M14 16.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0","key":"svg-3"}],["path",{"d":"M3 16.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0","key":"svg-4"}]]

const IconEyeglass2 = createReactComponent('outline', 'eyeglass-2', 'Eyeglass2', __iconNode);

export default IconEyeglass2;